export const LAYOUT = {
  SIDEBAR_WIDTH_EXPANDED: 240,
  SIDEBAR_WIDTH_MINI: 64,
  HEADER_HEIGHT: 64,
  CHAT_PANEL_WIDTH: { sm: 320, md: 400, lg: 450, xl: 500 },
  MAIN_CONTENT_MAX_WIDTH: 1400,
  MAIN_CONTENT_PADDING: 3,
  CHAT_OVERLAY_BREAKPOINT: 'md' as const,
} as const;

export const Z_INDEX = {
  SIDEBAR: 1100,
  HEADER: 1100,
  CHAT_PANEL: 1200,
  CHAT_PANEL_OVERLAY: 1300,
} as const;
